import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Comments, FilesComponent, Notes, SimpleTabs } from 'components';
import { commentModels, fileEnums, KeyPurpose, noteModels, PermissionList, RolePermission } from 'utils';
import { claimDetailTabsLabels } from './constants';
import { ClaimDetailHeader } from './claimDetailHeader';
import { ClaimDetailsTab } from './claimDetailsTab';
import { ClaimAppointments } from './claimAppointments';
import { HistoryTab } from '../../../history';
import { formModelEnums } from 'pages';

export const ClaimDetailInfo = ({ climId, afterSuccess, onClose }) => {
    const params = useParams();
    // Rendered inside the OpenClaimDetails modal (no route param) — fall back to the passed climId.
    const id = climId || params?.id;
    const [activeTab, setActiveTab] = useState('Details');

    const claimTabContent = [
        {
            tabComponent: <ClaimDetailsTab afterSuccess={afterSuccess} />,
            tab: 'Details',
        },
        {
            tabComponent: <ClaimAppointments />,
            tab: 'Appointments',
        },
        {
            tabComponent: (
                <Comments
                    afterSuccess={afterSuccess}
                    fromDetail={true}
                    resource={commentModels.Claim}
                    resourceId={id}
                    label={'Claim'}
                    width={700}
                    height={600}
                    attachmentPurpose={KeyPurpose.CLAIM_DOC}
                    enableAiImprove
                />
            ),
            tab: 'Comments',
        },
        RolePermission([PermissionList.CLAIM_NOTE_READ?.code, PermissionList.CLAIM_NOTE_MANAGE?.code]) && {
            tabComponent: (
                <Notes
                    id={id}
                    onModel={noteModels.Claim}
                    formModel={formModelEnums.CLAIMNOTES}
                    permissions={[PermissionList.CLAIM_NOTE_MANAGE?.code]}
                    saveParams={true}
                />
            ),
            tab: 'Notes',
        },
        RolePermission([PermissionList.CLAIM_HISTORY_READ?.code]) && {
            tabComponent: <HistoryTab currentId={id} onModel={'Claim'} saveParams={true} />,
            tab: 'History',
        },
        RolePermission([PermissionList.CLAIM_FILE_READ?.code, PermissionList.CLAIM_FILE_MANAGE?.code]) && {
            tabComponent: (
                <FilesComponent currentId={id} onResource={fileEnums.CLAIM} permissions={[PermissionList.CLAIM_FILE_MANAGE?.code]} />
            ),
            tab: 'Files',
        },
    ];

    return (
        <div className="tab-box-wrapper">
            <ClaimDetailHeader afterSuccess={afterSuccess} onClose={onClose} />
            <SimpleTabs
                tab={activeTab}
                getTab={setActiveTab}
                defaultTab={activeTab}
                tabsLabels={claimDetailTabsLabels}
                tabsContent={claimTabContent}
            />
        </div>
    );
};
